import { DataSetConfig } from 'libs/end-to-end/src/types/databases/data-sets/data-set';
import { POSTGRES_INTEGRATION_DEFAULT_RETRY_COUNT } from 'libs/end-to-end/src/types/databases/data-sets/postgres-integration-defaults';

export const createDefaultConfigForPostgresIntegration = (): DataSetConfig => {
  return {
    dataSetType: 'Integration',
    integration: {
      integrationType: 'Postgres',
      tables: [],
      retryCount: POSTGRES_INTEGRATION_DEFAULT_RETRY_COUNT,
      host: '',
      port: 5432,
      database: '',
      user: '',
      ssl: false,
      passwordReference: undefined,
    },
  };
};
